import { Transaction } from '@/types/crypto';
import { useGetTransactionsQuery } from '@/features/crypto/cryptoApi';

const getArgs = (page: number) => ({
  page,
  sortOrder: 'desc'
});

const queryOptions = {
  refetchOnMountOrArgChange: true,
  pollingInterval: 10 * 1000 // every 10s
};

export const useTransactions = (): { transactions: Transaction[] | undefined; isLoading: boolean } => {
  const transactionPages = [
    useGetTransactionsQuery(getArgs(1), queryOptions),
    useGetTransactionsQuery(getArgs(2), queryOptions),
    useGetTransactionsQuery(getArgs(3), queryOptions),
    useGetTransactionsQuery(getArgs(4), queryOptions),
    useGetTransactionsQuery(getArgs(5), queryOptions)
  ];

  return {
    transactions: transactionPages
      .reduce<Transaction[]>((transactions, { data }) => [...transactions, ...(data || [])], [])
      ?.filter((transaction) => !['created', 'user_timeout'].includes(transaction.transactionState)),
    // we can only use isLoading from the first page, because some of the later pages quite sure don't exist
    // thus on each refetch isLoading for this pages is true (and not just isFetching)
    // this would lead to randomly appearing spinners
    isLoading: transactionPages[0].isLoading
  };
};
